import { Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import OptionCard from '@/components/wrapped/OptionCard';
import StackPage from '@/karehero-app/shell/StackPage';
import {
  CALCULATOR_FORM,
  FORM_FIELDS,
} from '@/karehero-app/tell-us-once/benefits/BenefitsCalculator.content';

const noop = () => {};

// PROPOSED, as the thing to argue against. The same nineteen questions the chat
// asks, delivered as a form.
//
// One question per screen, on the shell the financial assessment already uses:
// StackPage, a Save & exit, a position counter, and a Next / Previous pair. A
// single scrolling page was the first draft of this and it was the wrong
// comparison — it argued against a form nobody would build.
//
// Built from the same screener as the chat rather than written to look bad. The
// prompts, the options and the order are the real ones, so what this shows is
// the question set in a different frame.
const CalculatorFormScreen = ({
  question,
}: {
  /** Harness-only: open on this question, named by its id. Defaults to first. */
  question?: string;
}) => {
  const found = FORM_FIELDS.findIndex((f) => f.id === question);
  const index = found >= 0 ? found : 0;
  const field = FORM_FIELDS[index];
  const last = index >= FORM_FIELDS.length - 1;

  return (
    <StackPage
      onBack={noop}
      backLabel='Save & exit'
      // Where you are in it: the number a form has to show and a conversation
      // never does.
      action={
        <Typography variant='caption' color='text.secondary'>
          {index + 1}/{FORM_FIELDS.length}
        </Typography>
      }
      footer={
        <Stack spacing={2}>
          <Button
            variant='primary'
            size='lg'
            isFullWidth
            ariaLabel={last ? CALCULATOR_FORM.primary : 'Continue'}
            onPress={noop}
          >
            {last ? CALCULATOR_FORM.primary : 'Continue'}
          </Button>
          <Button
            variant='secondary'
            size='lg'
            isFullWidth
            ariaLabel='Previous question'
            onPress={noop}
          >
            Previous
          </Button>
        </Stack>
      }
    >
      <Stack spacing={3}>
        <Typography variant='h2'>{field.label}</Typography>

        {/* Radio cards, never a dropdown, and always stacked — a yes/no included.
            llama's Boolean puts two side by side, but a column keeps every
            question on this form answered the same way down the same edge,
            rather than the target moving depending on how many answers there
            are. */}
        <Stack spacing={2}>
          {field.options.map((o) => (
            <OptionCard
              key={o}
              control={field.kind === 'multi' ? 'check' : 'radio'}
              selected={false}
              label={o}
              onClick={noop}
            />
          ))}
        </Stack>
      </Stack>
    </StackPage>
  );
};

export default CalculatorFormScreen;
